export const columns = [
  {
    title: "材料名称",
    dataIndex: "materialName",
    key: "materialName",
  },
  {
    title: "预算数量",
    dataIndex: "budgetCount",
    key: "budgetCount",
  },
];
